// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1pX7S","checkboxCol":"Table_checkboxCol__2hXaq","emailCol":"Table_emailCol__2MAzG","actionCol":"Table_actionCol__3WRFM"};